import { useEffect, useState } from "react"
import { _Report, _single } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../theme/Component/BasicPage"
import { toast } from "react-toastify"
import { DropDown } from "../../theme/Component/DropDown"
import { BasicTable } from "../../theme/Component/BasicTable"
import { ListMenu } from "../../theme/Component/ListMenu"
import useModal, { MODAL_md } from "../../theme/Component/hooks/useModal"
import { Modal } from "../../theme/Component/Modal"
import { SelectAvailableFilters } from "./Selectores/SelectAvailableFilters"
import { SelectAvailableParsers } from "./Selectores/SelectAvailableParsers"
import { ReportItem } from "../../../core/services/dataBean/quickDataErpCore/ReportItem"
import { ReportItems } from "./ReportItem/ReportItem"

export const Report = () => {
    const { instance, lista, setLista, bean, setBean } = useDataBean(_Report);

    const modal = useModal("Agregar Esquema de reporte", MODAL_md);
    const modalDelete = useModal("Eliminar Estructura de Reporte", MODAL_md);
    const modalItems = useModal(`Estructura del Reporte ${bean.Name}`, MODAL_md);
    const modalImport = useModal(`Importar Estructura del Reporte ${bean.Name}`, MODAL_md);

    useEffect(() => {
        getLista()
    }, [])

    const getLista = () => {
        instance.getReports(null).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        );
    }

    const head = [
        { title: 'ID', property: 'IDReport', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Filtro', property: 'DataFilterClassForName', visible: true },
        { title: 'Tipo Parser', property: 'DataParserClassForName', visible: true },
        { title: 'Tipo Estructura', property: 'DataTransferRecordClassForName', visible: true },
        { title: 'Tipo Estructura', property: 'DataTransferRecordClassForName', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Estructura del Reporte', icono: 'ri-list-check', visible: _single.canEdit(), evento: () => { modalItems.open() } },
            { titulo: 'Editar Estructura de reporte', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.setModal({ ...modal.modal, view: true, name: "Editar Esquema de reporte" }) } },
            // { titulo: 'Eliminar Estructura de reporte', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Migrar Modelos de Reportes', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }

                </div>
            </div>
        )
    }

    const actions = (e: any) => {

        if (e.id === 1) {
            migrarDatos()
        }
    }

    const migrarDatos = () => {
        instance.migrateReports(null).then(
            (resp) => {
                toast.success("Accion Realizada");
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    const create = () => {
        setBean({});
        modal.setModal({ ...modal.modal, view: true, name: "Agregar Esquema de reporte" })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    useEffect(() => {
        if (bean.DataParserClassForName && modal.modal.view)
            instance.getDataTransferRecordForDataParser(bean.DataParserClassForName).then(
                (resp) => {
                    setBean({ ...bean, DataTransferRecordClassForName: resp });
                }
            ).catch(
                err => { toast.error(err) }
            )
    }, [bean.DataParserClassForName])

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            updateReports()
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name", "DataFilterClassForName", "DataParserClassForName", "DataTransferRecordClassForName"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const updateReports = () => {
        instance.updateReport(bean).then(
            (resp) => {
                getLista();
                modal.close()
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteReport = () => {
        instance.deleteReport(bean.IDReport).then(
            (resp) => {
                getLista();
                modalDelete.close();
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <BasicPage titulo="Esquemas de Reportes Contable/Presupuestales" >
            <div className="row">
                <div className="col-md-12">
                    <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} headButtons={buttons()} body={lista} head={head} rowSet={setBean} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`}>Nombre</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('DataFilterClassForName') ? 'has-error' : ''}`}>Tipo de Filtro</label>
                                <SelectAvailableFilters idSelector={bean.DataFilterClassForName} onChange={(e) => { setBean({ ...bean, DataFilterClassForName: e }) }} label=" " />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('DataParserClassForName') ? 'has-error' : ''}`}>Tipo de Parser</label>
                                <SelectAvailableParsers idSelector={bean.DataParserClassForName} onChange={(e) => { setBean({ ...bean, DataParserClassForName: e }) }} label=" " />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('DataTransferRecordClassForName') ? 'has-error' : ''}`}>Tipo de Estructura</label>
                                <input type="text" className="form-control" value={bean.DataTransferRecordClassForName} disabled />
                            </div>

                        </div>
                    </Modal>

                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal}  >
                        <ReportItems idReport={bean.IDReport} />
                    </Modal>

                    <Modal modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={() => { deleteReport() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <p>¿Eliminar el Esquema de reporte {bean.Name}?</p>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={() => { }} >
                        <div className="row">
                            <div className="col-md-12">
                                <p>¿Eliminar el Esquema de reporte {bean.Name}?</p>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}